// Build-time site origin. VITE_SITE_URL drives production cutover (see
// vite.config.ts:siteUrlPlugin — the same env var rewrites index.html and
// the public/ trust files); the staging literal is the dev/unset fallback.
// Indexable builds fail fast in vite.config.ts if VITE_SITE_URL is unset.
export const SITE_URL = (
  import.meta.env.VITE_SITE_URL || 'https://imt-staging-gamerhood-s5-rao.statefarmgamerhood.com'
).replace(/\/+$/, '');

export type PageMetaEntry = {
  path: string;
  title: string;
  description: string;
};

export const PAGE_META = {
  home: {
    path: '/',
    title: 'State Farm Gamerhood - Season 5',
    description:
      "Jake's Neighborhood Swarm - streaming Fridays starting July 31, 6 PM EDT. Join the State Farm Gamerhood Season 5 activation.",
  },
  rules: {
    path: '/rules',
    title: 'Official Rules - State Farm Gamerhood Season 5',
    description:
      'Official Rules for the State Farm Gamerhood Season 5 activation. Coming soon.',
  },
  sweepstakes: {
    path: '/sweepstakes',
    title: 'Official Rules - State Farm Gamerhood Chair Giveaway',
    description:
      'Official Rules for the State Farm Gamerhood Chair Giveaway sweepstakes.',
  },
  privacy: {
    path: '/privacy',
    title: 'Privacy - State Farm Gamerhood',
    description:
      'Privacy disclosures for the State Farm Gamerhood Season 5 site. Operated by Infinity Marketing Team, LLC on behalf of State Farm.',
  },
  terms: {
    path: '/terms',
    title: 'Terms - State Farm Gamerhood',
    description:
      'Terms of use for the State Farm Gamerhood Season 5 site. Operated by Infinity Marketing Team, LLC on behalf of State Farm.',
  },
  privacySettings: {
    path: '/privacy-settings',
    title: 'Privacy Settings - State Farm Gamerhood',
    description:
      'Manage your analytics and tracking preferences for the State Farm Gamerhood Season 5 site.',
  },
  cookies: {
    path: '/cookies',
    title: 'Cookie Policy - State Farm Gamerhood',
    description:
      'Inventory of the cookies and similar storage technologies used on the State Farm Gamerhood Season 5 site.',
  },
  leaderboard: {
    path: '/leaderboard',
    title: 'Leaderboard - State Farm Gamerhood Season 5',
    description:
      "Top scores for Jake's Neighborhood Swarm — weekly leaderboards for State Farm Gamerhood Season 5.",
  },
  register: {
    path: '/register',
    title: 'Register - State Farm Gamerhood Season 5',
    description:
      "Sign up to play Jake's Neighborhood Swarm and compete for prizes in State Farm Gamerhood Season 5.",
  },
  weeklyRules: {
    path: '/weekly-rules',
    title: 'Weekly Rules - State Farm Gamerhood Season 5',
    description:
      "Agree to this week's official rules before playing Jake's Neighborhood Swarm.",
  },
  play: {
    path: '/play',
    title: 'Play - State Farm Gamerhood Season 5',
    description:
      "Jump into Jake's Neighborhood Swarm for State Farm Gamerhood Season 5.",
  },
  playGame: {
    path: '/play/game',
    title: 'Play - State Farm Gamerhood Season 5',
    description:
      "Jake's Neighborhood Swarm — State Farm Gamerhood Season 5.",
  },
  account: {
    path: '/account',
    title: 'Account - State Farm Gamerhood',
    description:
      'Manage your communication preferences and account for State Farm Gamerhood Season 5.',
  },
  emailPreferences: {
    path: '/email-preferences',
    title: 'Email Preferences - State Farm Gamerhood',
    description: 'Manage your email subscription for State Farm Gamerhood Season 5.',
  },
  admin: {
    path: '/admin',
    title: 'Admin Portal - State Farm Gamerhood',
    description: 'Administrative portal for State Farm Gamerhood Season 5.',
  },
  notFound: {
    path: '/404',
    title: 'Page not found - State Farm Gamerhood',
    description: 'The page you requested could not be found.',
  },
} as const satisfies Record<string, PageMetaEntry>;
